module.exports = __webpack_public_path__ + "img/Advanced Search - Blue - Selected.4b59ffa7.png";